import { motion } from "framer-motion";
import { socialIcons } from "../ui/icons";

const CONTACT_LINKS = [
  {
    label: "Email",
    value: "cherubini.franco@hotmail.com",
    href: "mailto:cherubini.franco@hotmail.com",
    icon: socialIcons.mail,
    external: false,
  },
  {
    label: "GitHub",
    value: "github.com/cherubinifranco",
    href: "https://github.com/cherubinifranco",
    icon: socialIcons.github,
    external: true,
  },
  {
    label: "LinkedIn",
    value: "linkedin.com/in/cherubinifranco",
    href: "https://linkedin.com/in/cherubinifranco",
    icon: socialIcons.linkedin,
    external: true,
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      className="border-t border-white/[0.06] bg-[#060B14] px-6 py-24 text-white sm:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="grid gap-12 lg:grid-cols-[0.7fr_1.3fr]"
        >
          <h2 className="mt-4 text-4xl font-medium tracking-[-0.05em] sm:text-5xl lg:text-6xl">
            Let's build
            <span className="block">something useful.</span>
          </h2>

          <div className="lg:pt-2">
            <p className="max-w-2xl text-lg leading-8 text-white/55">
              I'm always interested in discussing new projects, freelance
              opportunities, or interesting ideas. If you have something in
              mind, I'd be happy to hear about it.
            </p>

            <div className="mt-12 border-t border-white/[0.07]">
              {CONTACT_LINKS.map((contact, index) => (
                <motion.a
                  key={contact.label}
                  href={contact.href}
                  target={contact.external ? "_blank" : undefined}
                  rel={contact.external ? "noopener noreferrer" : undefined}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.15 + index * 0.08,
                    duration: 0.5,
                  }}
                  className="group flex items-center justify-between px-8 border-b border-white/[0.07] py-5 transition-colors hover:bg-white/[0.015]"
                >
                  <div className="flex items-center gap-4">
                    <span className="flex h-9 w-9 items-center justify-center text-white/35 transition-colors group-hover:border-white/15 group-hover:text-white/70">
                      {contact.icon}
                    </span>

                    <div>
                      <p className="text-xs uppercase tracking-[0.12em] text-white/25">
                        {contact.label}
                      </p>

                      <p className="mt-1 text-sm text-white/55 transition-colors group-hover:text-white">
                        {contact.value}
                      </p>
                    </div>
                  </div>

                  <span className="text-white/20 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-white/60">
                    ↗
                  </span>
                </motion.a>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
